import React from 'react';
import { usePlatform } from 'hooks';

export default Component => props => (
    <Component {...props} platform={usePlatform()} />
);
